import { loadScriptInHead } from '../../utils/dom';
import {get, isFunction} from 'lodash';

export function sendParselyPageview(currentUrl, newUrl) {
  if (!isFunction(get(window, 'PARSELY.beacon.trackPageView'))) {
    return;
  }

  window.PARSELY.beacon.trackPageView({
    urlref: currentUrl,
    url: newUrl,
    js: 1
  });
}

export default function Parsely(onProduction) {
  const parselyId = onProduction
    ? 'refinery29.com'
    : 'staging.refinery29.com';

  const parselyDiv = document.createElement('div');
  parselyDiv.id = 'parsely-root';
  parselyDiv.style = 'display: none';
  parselyDiv.innerHTML = `<span id="parsely-cfg" data-parsely-site="${parselyId}"></span>`;
  document.body.appendChild(parselyDiv);

  loadScriptInHead('statistics', 'https://d1z2jf7jlzjs58.cloudfront.net/p.js');
}
